import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { UserAccessProvider } from "context/UserAccessContext";
import { MultiStepFormProvider } from "features/loanApplications/context/MultiStepFormContext";
import { V3App } from "./v3";
import { getExperience } from "./shared/experience-toggle";
import { initRUM } from "./shared/rum";

// Initialize CloudWatch RUM (error tracking, performance, user sessions)
initRUM();

const root = ReactDOM.createRoot(document.getElementById("root")!);

// Redirect root path based on stored experience preference
if (window.location.pathname === "/" || window.location.pathname === "") {
  const exp = getExperience();
  if (exp === "v3") {
    window.location.replace("/v3/");
  }
}

// V3 has its own BrowserRouter, so render it outside the main app's Router
if (window.location.pathname.startsWith("/v3")) {
  root.render(<V3App />);
} else {
  root.render(
    <Router>
      <AuthProvider>
        <UserAccessProvider>
          <MultiStepFormProvider>
            <App />
          </MultiStepFormProvider>
        </UserAccessProvider>
      </AuthProvider>
    </Router>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
